module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/flag-removed-b3f0f1f51e4de49d9997d46f37248095.svg";